import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { Modal } from 'react-bootstrap';
import * as yup from 'yup';
import SvgDelete from '../../../assets/icons/Delete';
import { T } from '../../../components/basic/text';
import { FormikCellToggle } from '../../../components/formik/formik-cell-toggle';
import { FormikTextField } from '../../../components/formik/formik-text-field';
import { tileIconTypes } from '../../home/dashboard/sys-menu/tile-icons';
import { SysMenu } from './sys-menu-types';

type SysMenuModalProps = {
    current: SysMenu;
    show: boolean;
    onHide: () => void;
    onSave: (values: any, onHide: () => void) => void;
    onDelete: (values: any, onHide: () => void) => void;
};

export const SysMenuModal = ({ current, show, onHide, onSave, onDelete }: SysMenuModalProps) => {
    const insertMode = !current.id;

    const getIconCodes = () => {
        const icon_codes: any[] = [{ id: '', title: '' }];
        for (var p in tileIconTypes) icon_codes.push({ id: p, title: p });
        return icon_codes;
    };

    const getTileIcon = (menu: any) => {
        if (!menu.iconCode) return null;
        const icons: any = tileIconTypes;
        const x: any = icons[menu.iconCode];
        if (!x) return null;
        return <span className="size-sm p-e-2">{x({ className: menu.iconCss })}</span>;
    };

    const onSubmit = (values: any) => {
        onSave && onSave(values, onHide);
    };

    const onDeleteMenu = (values: SysMenu) => {
        bd.msgbox(
            <T>deleting-current-menu</T>,
            null,
            [
                {
                    title: <T>delete</T>,
                    action: (hide: () => void) => onDelete(values, hide),
                },
                { title: <T>close</T> },
            ],
            { backdropClassName: 'modal-n', className: 'modal-n' }
        );
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {!insertMode && <T append={'#' + current.id}>edit</T>}
                        {insertMode && <T>add</T>}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Formik
                        initialValues={current}
                        validationSchema={yup.object({
                            groupId: yup.string().nullable().required(' '),
                            id: yup.number().nullable().required(' '),
                            title: yup.string().nullable().required(' '),
                            url: yup.string().nullable().required(' '),
                        })}
                        onSubmit={onSubmit}
                    >
                        {formik => (
                            <Form>
                                {insertMode && (
                                    <FormikTextField
                                        name="id"
                                        label="Id"
                                        width="8rem"
                                        maxLength={3}
                                    />
                                )}
                                <bd.Flex wrap>
                                    <FormikTextField
                                        name="title"
                                        label="Title"
                                        width="15rem"
                                        maxLength={100}
                                        footer={
                                            <T className="m-s-2 px-1 bg-gray-5 rounded-pill small">
                                                {formik.values.title}
                                            </T>
                                        }
                                    />
                                    <FormikTextField
                                        name="subTitle"
                                        label="Sub Title"
                                        width="15rem"
                                        maxLength={100}
                                        footer={
                                            <T className="m-s-2 px-1 bg-gray-5 rounded-pill small">
                                                {formik.values.subTitle}
                                            </T>
                                        }
                                    />
                                    <FormikTextField
                                        name="footer"
                                        label="Footer"
                                        maxLength={100}
                                        width="15rem"
                                        className="m-e-0"
                                        footer={
                                            <T className="m-s-2 px-1 bg-gray-5 rounded-pill small">
                                                {formik.values.footer}
                                            </T>
                                        }
                                    />
                                </bd.Flex>

                                <bd.Flex wrap>
                                    <FormikTextField
                                        name="url"
                                        width="15rem"
                                        label="Url"
                                        maxLength={100}
                                        inputClassName="ltr"
                                    />
                                    <FormikTextField
                                        name="imageUrl"
                                        width="15rem"
                                        label="Image Url"
                                        maxLength={100}
                                        inputClassName="ltr small"
                                    />
                                    <FormikTextField
                                        name="coverImage"
                                        label="Cover Image"
                                        maxLength={100}
                                        width="15rem"
                                        className="m-e-0"
                                    />
                                </bd.Flex>

                                <bd.Flex wrap>
                                    <FormikTextField
                                        name="iconCss"
                                        label="Icon CSS"
                                        maxLength={100}
                                        width="15rem"
                                    />
                                    <FormikTextField
                                        name="iconCode"
                                        label="Icon Code"
                                        maxLength={100}
                                        width="12rem"
                                        type="select"
                                        items={getIconCodes()}
                                    />

                                    <bd.FormRow width="2rem" label="" controlClassName="pt-2">
                                        {getTileIcon(formik.values)}
                                    </bd.FormRow>

                                    <FormikTextField
                                        name="cssClass"
                                        width="15rem"
                                        label="CSS Class"
                                        maxLength={100}
                                        className="m-e-0"
                                    />
                                </bd.Flex>

                                <FormikTextField
                                    name="indicatorCode"
                                    width="w-100"
                                    label="Indicator Code"
                                    maxLength={100}
                                    inputClassName="ltr small"
                                    inputStyle={{ fontSize: 13.5, fontFamily: 'consolas' }}
                                />

                                <bd.Flex wrap>
                                    <FormikTextField
                                        name="indicatorUnit"
                                        label="Indicator Unit"
                                        maxLength={100}
                                        width="15rem"
                                    />
                                    <FormikTextField
                                        name="indicatorArrow"
                                        label="Indicator Arrow"
                                        maxLength={100}
                                        width="15rem"
                                    />
                                    <FormikTextField
                                        name="indicatorCss"
                                        label="Indicator Css"
                                        maxLength={100}
                                        width="15rem"
                                        className="m-e-0"
                                    />
                                </bd.Flex>

                                <bd.Flex wrap>
                                    <FormikTextField
                                        name="roleNames"
                                        label="Role Names"
                                        maxLength={100}
                                        width="15rem"
                                    />
                                    <FormikTextField
                                        name="templateCode"
                                        label="Template Code"
                                        maxLength={100}
                                        width="15rem"
                                    />
                                    <FormikTextField
                                        name="separatorName"
                                        label="Separator Name"
                                        maxLength={100}
                                        width="15rem"
                                        className="m-e-0"
                                    />
                                </bd.Flex>

                                <bd.Flex className="my-4 gap-x-4" wrap>
                                    <FormikCellToggle
                                        className="mx-2"
                                        name="visible"
                                        title="Visible"
                                    />
                                    <FormikCellToggle className="mx-2" name="isWide" title="Wide" />
                                    <FormikCellToggle className="mx-2" name="isFeed" title="Feed" />
                                    <FormikCellToggle className="mx-2" name="isLink" title="Link" />
                                    <FormikCellToggle name="deleteRights" title="Delete Rights" />
                                </bd.Flex>

                                <bd.FormRow className="py-1 m-e-0">
                                    {!insertMode && (
                                        <bd.Button
                                            size="md"
                                            variant="outline"
                                            color="secondary"
                                            className="min-w-80 "
                                            type="button"
                                            onClick={() => onDeleteMenu(current)}
                                        >
                                            <T>delete</T>
                                            <SvgDelete />
                                        </bd.Button>
                                    )}
                                    <bd.Button
                                        type="submit"
                                        variant="contained"
                                        className="m-s-auto m-e-2"
                                        disabled={!formik.isValid}
                                    >
                                        <T>save-changes</T>
                                    </bd.Button>

                                    <bd.Button
                                        variant="outline"
                                        className="min-w-80"
                                        type="button"
                                        onClick={onHide}
                                    >
                                        <T>cancel</T>
                                    </bd.Button>
                                </bd.FormRow>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
};
